<template>
    <div class="sample-make-order">
        <a-breadcrumb separator=">">
            <a-breadcrumb-item>
                <router-link to="/sample">
                    <img src="../../assets/control/breadcrumb.svg" style="margin: 0 4px 4px 0" />控制样
                </router-link>
            </a-breadcrumb-item>
            <a-breadcrumb-item>
                <router-link to="/sample/sample-order">控制样订购</router-link>
            </a-breadcrumb-item>
            <a-breadcrumb-item>订单编辑</a-breadcrumb-item>
        </a-breadcrumb>

        <div class="flow">
            <custom-form ref="static-form" :panels="baseFields" :fieldsValue="baseValue"></custom-form>

            <a-form v-if="dynamicFields.length">
                <a-form-item
                    v-for="field in dynamicFields"
                    :key="field.sampleTypeParameterId"
                    :label="field.parametername"
                >
                    <component
                        v-model="dynamicValue[field.sampleTypeParameterId]"
                        :is="field.inputType"
                        :showSearch="field.showSearch"
                        :allowClear="field.allowClear"
                        :show-time="field.showTime"
                        :disabled="field.disabled"
                        :valueFormat="field.valueFormat ?? 'YYYY-MM-DD'"
                        :placeholder="field.placeholder"
                    ></component>
                </a-form-item>
            </a-form>

            <div class="btns">
                <a-button @click="close">关闭</a-button>
                <a-button type="primary" @click="save">保存</a-button>
            </div>
        </div>
    </div>
</template>

<script>
import customForm from '@/components/custom-form.vue';
import { getSampleDynamicIpt, getSampleOrderDetail, updateSampleOrder } from '../../common/api';
import { getJsonWrapper } from '../../common/utils';

export default {
    components: { customForm },

    data() {
        return {
            baseFields: [
                {
                    id: 'baseFields',
                    gutter: 12,
                    fieldGroup: [
                        [
                            {
                                label: '订购类型',
                                field: 'sampletypename',
                                disabled: true,
                                span: 12,
                                labelCol: { span: 6 },
                                wrapperCol: { span: 18 }
                            },
                            {
                                label: '订购单位名称',
                                field: 'clientName',
                                span: 12,
                                labelCol: { span: 6 },
                                wrapperCol: { span: 18 }
                            }
                        ],
                        [
                            {
                                label: '订购单位地址',
                                field: 'clientAddress',
                                span: 12,
                                labelCol: { span: 6 },
                                wrapperCol: { span: 18 }
                            },
                            {
                                label: '联系人姓名',
                                field: 'contactName',
                                span: 12,
                                labelCol: { span: 6 },
                                wrapperCol: { span: 18 }
                            }
                        ],
                        [
                            {
                                label: '联系电话',
                                field: 'contactPhone',
                                span: 12,
                                labelCol: { span: 6 },
                                wrapperCol: { span: 18 }
                            },
                            {
                                label: '邮编',
                                field: 'zipCode',
                                span: 12,
                                labelCol: { span: 6 },
                                wrapperCol: { span: 18 }
                            }
                        ],
                        [
                            {
                                label: '传真',
                                field: 'fax',
                                span: 12,
                                labelCol: { span: 6 },
                                wrapperCol: { span: 18 }
                            },
                            {
                                label: '备注',
                                field: 'remark',
                                span: 12,
                                labelCol: { span: 6 },
                                wrapperCol: { span: 18 }
                            }
                        ]
                    ]
                }
            ],
            baseValue: {
                sampletypename: '',
                clientAddress: '',
                contactName: '',
                contactPhone: '',
                zipCode: '',
                fax: '',
                remark: '',
                clientName: ''
            },
            dynamicFields: [],
            iptTypeMapper: {
                number: 'a-input-number',
                select: 'a-select',
                date: 'a-date-picker',
                string: 'a-input'
            },
            dynamicValue: {}
        };
    },

    computed: {
        orderId() {
            return this.$route.query?.id;
        }
    },

    mounted() {
        this.getDynamicList();
        this.getDetail();
    },

    methods: {
        async getDynamicList() {
            if (!this.orderId) {
                return this.$message.error('缺少订单id');
            }
            const { data } = await getSampleDynamicIpt(this.orderId);
            this.dynamicFields = data.ordersParamterList.map(t => {
                return {
                    inputType: this.iptTypeMapper[t.ext$.datatype],
                    placeholder: '请输入',
                    ...t.ext$,
                    ...t
                };
            });
        },

        async getDetail() {
            const { data } = await getSampleOrderDetail(this.orderId);
            this.baseValue.sampletypename = data.ext$.sampletypename;
            for (const key in this.baseValue) {
                if (data[key]) {
                    this.baseValue[key] = data[key];
                }
            }
            this.$nextTick(() => {
                this.$refs['static-form'].form.setFieldsValue(this.baseValue);
            });
        },

        async save() {
            const form = this.$refs['static-form'].form;
            form.validateFields(async (err, values) => {
                this.baseValue = values;
                this.baseValue.id = this.orderId;
                if (!err) {
                    const params = getJsonWrapper(
                        {},
                        ['cssControlSampleOrderServiceImpl', [this.baseValue]],
                        ['cssControlSampleOrderParameterServiceImpl', [this.dynamicValue]]
                    );
                    await updateSampleOrder(params);
                    this.$message.success('保存订单成功！');
                    this.$router.push({ path: '/sample/sample-search'});
                }
            });
        },

        close() {
            this.$router.back();
        }
    }
};
</script>

<style lang="scss" scoped>
.sample-make-order {
    width: 1200px;

    .flow {
        background: #ffffff;
        border-radius: 4px;
        padding: 16px;
        min-height: 500px;

        ::v-deep {
            .custom-form {
                .ant-input[disabled] {
                    border: 1px solid #d9d9d9;
                    color: rgba(0, 0, 0, 0.25);
                    background-color: #f5f5f5;
                    cursor: not-allowed;
                    opacity: 1;
                }
            }
        }

        .btns {
            display: flex;
            justify-content: center;
            margin-top: 40px;

            .ant-btn {
                margin-right: 16px;
            }
        }
    }
}
</style>
